var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateCollectionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_45099)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_45099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_45099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 26C19.1022 26 18.7206 26.158 18.4393 26.4393C18.158 26.7206 18 27.1022 18 27.5C18 27.8978 18.158 28.2794 18.4393 28.5607C18.7206 28.842 19.1022 29 19.5 29V26ZM27.5 29C27.8978 29 28.2794 28.842 28.5607 28.5607C28.842 28.2794 29 27.8978 29 27.5C29 27.1022 28.842 26.7206 28.5607 26.4393C28.2794 26.158 27.8978 26 27.5 26V29ZM7.5 23H39.5V20H7.5V23ZM42 25.5V33.5H45V25.5H42ZM35.5 40H11.5V43H35.5V40ZM5 33.5V25.5H2V33.5H5ZM11.5 40C9.77609 40 8.12279 39.3152 6.90381 38.0962C5.68482 36.8772 5 35.2239 5 33.5H2C2 36.0196 3.00089 38.4359 4.78249 40.2175C6.56408 41.9991 8.98044 43 11.5 43V40ZM42 33.5C42 35.2239 41.3152 36.8772 40.0962 38.0962C38.8772 39.3152 37.2239 40 35.5 40V43C36.7476 43 37.9829 42.7543 39.1355 42.2769C40.2881 41.7994 41.3354 41.0997 42.2175 40.2175C43.0997 39.3354 43.7994 38.2881 44.2769 37.1355C44.7543 35.9829 45 34.7476 45 33.5H42ZM39.5 23C40.163 23 40.7989 23.2634 41.2678 23.7322C41.7366 24.2011 42 24.837 42 25.5H45C45 24.0413 44.4205 22.6424 43.3891 21.6109C42.3576 20.5795 40.9587 20 39.5 20V23ZM7.5 20C6.04131 20 4.64236 20.5795 3.61091 21.6109C2.57946 22.6424 2 24.0413 2 25.5H5C5 24.837 5.26339 24.2011 5.73223 23.7322C6.20107 23.2634 6.83696 23 7.5 23V20ZM11.5 15H35.5V12H11.5V15ZM38 17.5V21.5H41V17.5H38ZM9 21.5V17.5H6V21.5H9ZM35.5 15C36.163 15 36.7989 15.2634 37.2678 15.7322C37.7366 16.2011 38 16.837 38 17.5H41C41 16.0413 40.4205 14.6424 39.3891 13.6109C38.3576 12.5795 36.9587 12 35.5 12V15ZM11.5 12C10.0413 12 8.64236 12.5795 7.61091 13.6109C6.57946 14.6424 6 16.0413 6 17.5H9C9 16.837 9.26339 16.2011 9.73223 15.7322C10.2011 15.2634 10.837 15 11.5 15V12ZM15.5 7H31.5V4H15.5V7ZM34 9.5V13.5H37V9.5H34ZM13 13.5V9.5H10V13.5H13ZM31.5 7C32.163 7 32.7989 7.26339 33.2678 7.73223C33.7366 8.20107 34 8.83696 34 9.5H37C37 8.04131 36.4205 6.64236 35.3891 5.61091C34.3576 4.57946 32.9587 4 31.5 4V7ZM15.5 4C14.0413 4 12.6424 4.57946 11.6109 5.61091C10.5795 6.64236 10 8.04131 10 9.5H13C13 8.83696 13.2634 8.20107 13.7322 7.73223C14.2011 7.26339 14.837 7 15.5 7V4ZM19.5 29H27.5V26H19.5V29Z",
    fill: "#28303F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_45099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCollectionIcon);
export default __webpack_public_path__ + "static/media/create-collection-icon.94d9b4d4647b7de3848b6a7f846a0b31.svg";
export { ForwardRef as ReactComponent };